export { default as getNumberString } from './getNumberString.js';
export { default as getNumberValue } from './getNumberValue.js';
export { default as getNumberValues } from './getNumberValues.js';
export { default as getValue } from './getValue.js';
export { default as metaDataProvider } from './metaDataProvider.js';
